import React from 'react'
import { Box, Typography, Grid } from '@mui/material'
import DayCard from './DayCard'

const formatDateRange = (startDate, endDate) => {
  const start = new Date(startDate)
  const end = new Date(endDate)

  const startMonth = start.toLocaleString('default', { month: 'short' })
  const startDay = start.getDate()
  const endMonth = end.toLocaleString('default', { month: 'short' })
  const endDay = end.getDate()

  if (startMonth === endMonth) {
    return `${startMonth} ${startDay}-${endDay}`
  }
  return `${startMonth} ${startDay} - ${endMonth} ${endDay}`
}

const WeekSelector = ({
  week,
  selectedDateIds,
  reservedDateIds = [],
  onToggleDate
}) => {
  const dateRange = formatDateRange(week.startDate, week.endDate)

  return (
    <Box my={3}>
      <Typography variant='subtitle1' fontWeight='bold' gutterBottom>
        {dateRange}
        {week.title && `: ${week.title}`}
      </Typography>
      {week.description && (
        <Typography variant='body2' color='text.secondary' paragraph>
          {week.description}
        </Typography>
      )}
      <Grid container spacing={2}>
        {week.locationDays.map(day => {
          const isSelected = selectedDateIds.includes(day.id)
          const isReserved = reservedDateIds.includes(day.id)
          return (
            <Grid item xs={12} sm={6} md={2.4} key={day.id}>
              <DayCard
                day={day}
                isSelected={isSelected}
                isReserved={isReserved}
                onToggle={() => onToggleDate(day)}
              />
            </Grid>
          )
        })}
      </Grid>
    </Box>
  )
}

export default WeekSelector
